import { render, staticRenderFns } from "./FiltersBlockTenders.vue?vue&type=template&id=5aa5d42c&scoped=true"
import script from "./FiltersBlockTenders.vue?vue&type=script&lang=js"
export * from "./FiltersBlockTenders.vue?vue&type=script&lang=js"
import style0 from "./FiltersBlockTenders.vue?vue&type=style&index=0&id=5aa5d42c&prod&lang=scss&scoped=true"
import style1 from "./FiltersBlockTenders.vue?vue&type=style&index=1&id=5aa5d42c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5d42c",
  null
  
)

export default component.exports